var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewModeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4175 1C12.4175 1.55 11.9675 2 11.4175 2H3.8275L12.7075 10.88C13.0975 11.27 13.0975 11.9 12.7075 12.29C12.3175 12.68 11.6875 12.68 11.2975 12.29L2.4175 3.41V11C2.4175 11.55 1.9675 12 1.4175 12C0.8675 12 0.4175 11.55 0.4175 11V1C0.4175 0.45 0.8675 0 1.4175 0H11.4175C11.9675 0 12.4175 0.45 12.4175 1Z",
    fill: "#53D8AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewModeIcon);
export default __webpack_public_path__ + "static/media/view_mode_icon.e757b6e7fdf40a19966116896291ceaf.svg";
export { ForwardRef as ReactComponent };